module.exports = __webpack_public_path__ + "static/media/people-3.e378452f.jpg";